<template>
  <div class="about">
    <div class="bodyblock">
      <div class="header">
        <h1>智能照护平台</h1>
        <div class="zhiliang">
          <router-link to="/rcmpage">实时养老服务质量</router-link>
        </div>
      </div>
      <div class="searchblock">
        <div>
          <img src="../assets/about/search.png" alt="" />
        </div>
        <div class="search">
          <el-select
            v-model="username"
            @clear="clearName"
            clearable
            @change="changeName"
            filterable
            remote
            :remote-method="remoteMethod"
            placeholder="请输入搜索"
          >
            <el-option
              v-for="item in seachList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="mian">
        <div class="leftblock">
          <el-dialog
            :title="username"
            :visible.sync="chiocepopup"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
          >
            <el-form>
              <el-form-item label="护理员">
                <el-select
                  v-model="huliname"
                  filterable
                  remote
                  :remote-method="hulinameMethod"
                  @clear="clearhuliName"
                  clearable
                  :loading="false"
                  :remote-show-suffix="false"
                  :debounce="300"
                  placeholder="请输入护理员姓名搜索"
                  @focus="onHuliSelectFocus"
                  @change="onHuliSelectChange"
                  @visible-change="onHuliSelectVisibleChange"
                >
                  <el-option
                    v-for="item in nurser"
                    :key="item.userId"
                    :label="item.nickName || item.userName"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="开始时间">
                <el-time-picker
                  v-model="startTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="选择开始时间"
                  style="width: 100%;"
                  @change="onStartTimeChange"
                >
                </el-time-picker>
              </el-form-item>
              <el-form-item label="结束时间">
                <el-time-picker
                  v-model="endTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="选择结束时间"
                  style="width: 100%;"
                >
                </el-time-picker>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="CancelPop">取 消</el-button>
              <el-button type="primary" @click="checkTimeConflict">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 时间冲突确认弹窗 -->
          <el-dialog
            title="时间冲突确认"
            :visible.sync="conflictDialogVisible"
            :close-on-click-modal="false"
            width="500px"
          >
            <div class="conflict-content">
              <p style="color: #ff6b6b; margin-bottom: 15px;">该时间段与以下任务存在冲突：</p>
              <div v-for="(item, index) in conflictPreview" :key="index" style="margin-bottom: 10px; padding: 10px; background: #f5f5f5; border-radius: 5px;">
                <div v-if="item.type === 'delete'" style="color: #ff4d4f;">
                  <strong>[将被删除]</strong> {{ item.original.timeSlot }} - {{ item.original.activity }}
                </div>
                <div v-else-if="item.type === 'modify'" style="color: #faad14;">
                  <strong>[将被调整]</strong> {{ item.original.timeSlot }} → {{ item.newTimeSlot }} - {{ item.original.activity }}
                </div>
                <div v-else-if="item.type === 'split'" style="color: #1890ff;">
                  <strong>[将被分割]</strong> {{ item.original.timeSlot }} - {{ item.original.activity }}
                  <div style="margin-left: 20px; margin-top: 5px; font-size: 12px;">
                    <div v-if="item.frontTimeSlot">└ 前半部分: {{ item.frontTimeSlot }}</div>
                    <div v-if="item.backTimeSlot">└ 后半部分: {{ item.backTimeSlot }}</div>
                    <div v-if="!item.frontTimeSlot && !item.backTimeSlot" style="color: #ff4d4f;">└ 时间过短，将被删除</div>
                  </div>
                </div>
              </div>
              <p style="margin-top: 15px; color: #666;">确认要继续添加吗？</p>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="conflictDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="confirmWithConflict">确认添加</el-button>
            </div>
          </el-dialog>
          <div
            class="userinfo"
            v-for="(item, index) in seachUser"
            :key="index"
            @click="findtimeLine(item.id)"
          >
            <div class="userbody" style="overflow: hidden">
              <div class="usertitle">{{ item.name }}（{{ item.age }}岁）</div>
              <div class="line">
                <draggable
                  class="drag-wrapper top3_drag-wrapper"
                  :animation="300"
                  forceFallback="true"
                  @start="drag = false"
                  filter=".forbid"
                  :group="{
                    name: 'list',
                    pull: false,
                    put: true,
                  }"
                  :force-fallback="true"
                  @add="personadd(item.id, $event)"
                  v-model="hulitimeline"
                  :move="checkMove"
                >
                  <!-- <div
                    v-for="(activity, index) in item.hulitimeline"
                    :key="index"
                  >
                    时间{{ activity.TimeSlot }}<br />
                    {{ activity.Activity }}
                    {{ activity.name }}
                  </div> -->

                  <el-timeline>
                    <el-timeline-item
                      v-for="(activity, index) in item.hulitimeline"
                      :key="index"
                      :timestamp="activity.timeSlot"
                    >
                      {{ activity.activity }}
                    </el-timeline-item>
                  </el-timeline>
                </draggable>
              </div>
            </div>
            <!-- //改 -->
            <div class="tooltip">{{ item.note }}</div>
          </div>
        </div>
        <div class="centerblock">
          <div class="setandhuli">
            <div class="huli">
              <div class="hulititle">
              </div>
              <div class="block">
                <el-cascader
                  v-if="!isNursingLoading && childrenList.length > 0"
                  placeholder="请选择/搜索护理动作"
                  :options="childrenList"
                  :props="{
                    value: 'id',
                    label: 'label',
                    children: 'children',
                    checkStrictly: true,
                    emitPath: true
                  }"
                  filterable
                  @change="huliaction"
                ></el-cascader>
                <div v-else-if="isNursingLoading" style="color: #00ffff; text-align: center; padding: 10px;">
                  护理动作加载中...
                </div>
                <div v-else style="color: #00ffff; text-align: center; padding: 10px;">
                  未找到护理动作数据
                </div>
              </div>
              <draggable
                v-model="myArray"
                chosenClass="chosen"
                forceFallback="true"
                :group="{
                  name: 'list',
                  pull: 'clone',
                  put: false,
                }"
                animation="1000"
                v-if="actiontrue"
                class="actionitem"
              >
                <transition-group>
                  <div
                    class="item"
                    v-for="element in myArray"
                    :key="element.id"
                    style="margin-top: 0.5vw"
                  >
                    {{ element.name }}
                  </div>
                </transition-group>
              </draggable>
            </div>
          </div>
          <div class="cenicon" v-if="setopen">
            <img src="../assets/about/fanhui.png" alt="" @click="rightClose" />
          </div>
          <div class="setblock" v-else>
            <div class="set">
              <div>
                <el-button round @click="clickbaocun">生成计划</el-button>
              </div>
            </div>
            <div class="closeicon">
              <img src="../assets/about/close.png" alt="" @click="rightClose" />
            </div>
          </div>
        </div>
        <div class="elderInfo" v-for="item in showUser" :key="item.id">
          <div>{{ item.name }}（{{ item.age }}岁）</div>
        </div>
        <div style="width: 100%" v-if="timelineList !== null">
          <horizontal-timeline
            class="horizontal-timeline"
            :timelineList="timelineList"
            :leftArrowShow="true"
            :rightArrowShow="true"
            :mousewheelDisable="true"
            :showScroll="false"
            :positionId="20"
            @right-loading="right"
            @left-loading="left"
            ref="timeline"
          >
            <template v-slot:default="slotProps">
              <div class="content">
                <div class="chat">
                  <div v-if="slotProps.item.activity !== ''">
                    {{ slotProps.item.activity }}
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:time="slotProps">
              <div class="time">
                {{ slotProps.item.timeSlot }}
                <div
                  style="margin-top: 5px"
                  v-if="slotProps.item.caregiver != 'None'"
                >
                  护理员：{{ slotProps.item.caregiver }}
                </div>
              </div>
            </template>
          </horizontal-timeline>
        </div>
        <div
          style="
            height: 250px;
            font-size: 30px;
            margin: 0 auto;
            line-height: 250px;
            color: #00ffff;
          "
          v-if="timelineList.length === 0 && !isLoading"
        >
          暂无数据
        </div>
        <div
          style="
            height: 250px;
            font-size: 30px;
            margin: 0 auto;
            line-height: 250px;
            color: #00ffff;
          "
          v-if="isLoading"
        >
          数据加载中...
        </div>
      </div>
    </div>
    <!-- <AMapLoader /> -->
  </div>
</template>
<script>
import moment from "moment";
import draggable from "vuedraggable";
import AMapLoader from '../components/Amap.vue';
import { getUserinfo, timeLine, adjust } from "@/api/user";
import { gethuliyuan, getAppUserList } from "@/api/huli";
import HorizontalTimeline from "@/components/vue-horizontal-timeline-component/src/vue-horizontal-timeline-component.vue";
export default {
  components: { draggable, HorizontalTimeline,AMapLoader },
  data() {
    return {
      timelineList: [],
      isLoading: false,
      isNursingLoading: false, // 添加护理动作加载状态
      drag: false,
      //定义要被拖拽对象的数组
      myArray: [],
      username: "", //搜索框
      searchicon: true,
      setopen: false,
      setclose: false,
      myAction: [], //护理动作
      actiontrue: false, //护理动作的显示
      seachUser: [], //搜索信息
      seachList: {},
      nursingAction: {
        name: "护理动作",
        children: []
      }, //护理动作
      hulitimeline: [], //护理时间线
      TimeSlotarray: [], //曲线图展示的时间段
      childrenList: [], // 初始化为空数组
      timevalue: "", //选择的时间段
      startTime: "", //开始时间
      endTime: "", //结束时间
      huliname: "", //选中的护理员
      chiocetimes: "", //展示的时间段
      chiocepopup: false, //弹窗
      conflictDialogVisible: false, //冲突确认弹窗
      conflictPreview: [], //冲突预览列表
      pendingNewItem: null, //待添加的新项目
      pendingAdjustments: [], //待处理的调整项
      list2: [],
      demoshow: false, //曲线图的显示
      // 查询护理员
      nurser: null,
      // 拖拽护理动作
      Nustime: "",
      user: null,
      showUser: [],
      chartsData: {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        },
        yAxis: {
          type: "time",
          min: "2024-08-03 00:00",
          max: "2024-08-03 23:59",
          scale: false,
          splitNumber: 10,
          axisLabel: {
            color: "#FFF",
          },
        },
        series: [
          {
            data: [
              "2024-08-03 04:00",
              "2024-08-03 11:00",
              "2024-08-03 15:00",
              "2024-08-03 17:00",
              "2024-08-03 13:00",
              "2024-08-03 12:00",
            ],
            type: "line",
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                return params.value.split(" ")[1]; // 显示y值
              },
              color: "#FFF",
            },
          },
        ],
      },
      list: [],
      events: [
        { title: "事件 1", description: "描述 1", date: "2023-01-01" },
        { title: "事件 2", description: "描述 2", date: "2023-02-01" },
        { title: "事件 3", description: "描述 3", date: "2023-03-01" },
        { title: "事件 4", description: "描述 4", date: "2023-04-01" },
        { title: "事件 5", description: "描述 5", date: "2023-05-01" },
      ],
      activities: [
        {
          content: "Custom icon",
          timestamp: "2018-04-12 20:46",
          size: "large",
          type: "primary",
          // icon: MoreFilled,
        },
        {
          content: "Custom color",
          timestamp: "2018-04-03 20:46",
          color: "#0bbd87",
        },
        {
          content: "Custom size",
          timestamp: "2018-04-03 20:46",
          size: "large",
        },
        {
          content: "Custom hollow",
          timestamp: "2018-04-03 20:46",
          type: "primary",
          hollow: true,
        },
        {
          content: "Default node",
          timestamp: "2018-04-03 20:46",
        },
      ],
      items: [],
      rightComplete: false,
      leftComplete: false,
      firstSelection: true,
      touchStartX: 0,
      touchStartY: 0,
      isTouching: false
    };
  },
  mounted() {
    // 支持 id 或 Id 参数（大小写不敏感）
    let id = this.$route.query.id || this.$route.query.Id;
    console.log('URL查询参数:', this.$route.query);
    console.log('获取到的id:', id);
    if (id) {
      // 如果URL中有指定的老人ID，则加载该老人信息
      console.log('准备调用changeName, id=', id);
      this.changeName(id);
    } else {
      // 没有id参数，默认加载前5条数据
      console.log('没有id参数，加载默认数据');
      this.loadDefaultData();
    }
    this.findnursing(); // 只调用 findnursing 方法，它会处理所有护理动作相关的数据
    document.onselectstart = function () {
      return false;
    };

    this.$nextTick(() => {
      this.setupTouchEvents();
    });
  },
  computed: {},
  methods: {
    clickrcm() {
      this.$router.push({ url: "/rcmpage" });
    },
    rightClose() {
      this.setopen = !this.setopen;
    },
    // 当选择开始时间后，自动同步结束时间
    onStartTimeChange(val) {
      if (val) {
        this.endTime = val;
      }
    },
    changetime(e) {
      let timevalue = moment(e, "HH:mm").add(30, "minute").format("HH:mm");
      if (this.timevalue == "23:30") {
        timevalue = "24:00";
      }
      if (this.timevalue == "24:00") {
        this.timevalue = "00:00";
      }
      this.chiocetimes = `${this.timevalue}-${timevalue}`;
    },
    handleClose() {},
    // 老人信息请求（仅在需要时调用，如清空搜索框时）
    userInfo() {
      // 清空之前的数据
      this.seachUser = [];
      this.seachList = [];
      this.showUser = [];
      this.timelineList = [];

      // 不发送请求获取所有数据，因为数据量可能很大
      this.$message.info("请输入搜索条件");
    },
    // 加载默认数据（前5条老人信息）
    loadDefaultData() {
      this.isLoading = true;
      
      getUserinfo({
        id: '',
        name: '',
        pageNum: 1,
        pageSize: 5
      }).then((res) => {
        if (res.data && res.data.rows && res.data.rows.length > 0) {
          let seachUser = res.data.rows.slice(0, 5);
          
          // 为每个用户获取时间线信息
          let promises = seachUser.map((item, index) => {
            return timeLine({ id: item.id }).then((res) => {
              let line = res.data.data;
              if (line && Array.isArray(line)) {
                line = line.map(timeItem => {
                  return {
                    activity: timeItem.Activity || '',
                    activityId: timeItem.ActivityId || '',
                    caregiver: timeItem.Caregiver || 'None',
                    caregiverId: timeItem.CaregiverId || '',
                    timeSlot: timeItem.TimeSlot || ''
                  };
                });
              } else {
                line = [];
              }
              item.hulitimeline = line;
              if (index == 0) {
                this.timelineList = line;
              }
              return item;
            }).catch(() => {
              item.hulitimeline = [];
              if (index == 0) {
                this.timelineList = [];
              }
              return item;
            });
          });

          Promise.all(promises).then((updatedUsers) => {
            this.seachUser = updatedUsers;
            this.showUser = updatedUsers;
            this.seachList = updatedUsers;
            this.isLoading = false;
          }).catch(() => {
            this.isLoading = false;
          });
        } else {
          this.isLoading = false;
        }
      }).catch((error) => {
        console.error("加载默认数据失败", error);
        this.isLoading = false;
      });
    },
    //查询护理动作
    findnursing() {
      console.log("开始调用 findnursing 方法");
      this.isNursingLoading = true; // 开始加载护理动作

      gethuliyuan().then((res) => {
        console.log("API返回的完整响应:", res);

        // 检查返回的数据结构
        if (res && res.data && Array.isArray(res.data)) {
          console.log("API返回的原始数据:", res.data);

          try {
            // 将返回的数据进行深拷贝，以便进行处理
            let dataClone = JSON.parse(JSON.stringify(res.data));

            // 处理数据，确保每个节点都有name字段
            const processNodes = (nodes) => {
              if (!nodes || !Array.isArray(nodes)) return;

              nodes.forEach(node => {
                // 将label字段映射为name字段
                if (node.label && !node.name) {
                  node.name = node.label;
                }

                // 递归处理子节点
                if (node.children && Array.isArray(node.children)) {
                  processNodes(node.children);
                }
              });
            };

            // 处理数据
            processNodes(dataClone);

            // 保存完整的树形结构
            this.nursingAction = {
              name: "护理动作",
              children: dataClone
            };

            // 设置级联选择器使用的数据
            this.childrenList = dataClone;

            // 同时将数据保存到nurser中，避免再次调用API
            this.nurser = res.data;

            console.log("处理后的护理动作树形结构:", this.nursingAction);
            console.log("处理后的护理动作列表:", this.childrenList);

            this.$nextTick(() => {
              // 强制刷新级联选择器
              this.childrenList = [...this.childrenList];
            });
          } catch (error) {
            console.error("处理护理动作数据时出错:", error);
            this.$message.error("处理护理动作数据时出错");
          }
        } else {
          console.error("API返回的数据结构不符合预期:", res);

          // 尝试从不同的路径获取数据
          if (res && res.data && res.data.data && Array.isArray(res.data.data)) {
            console.log("尝试从res.data.data获取数据:", res.data.data);

            try {
              // 将返回的数据进行深拷贝，以便进行处理
              let dataClone = JSON.parse(JSON.stringify(res.data.data));

              // 处理数据，确保每个节点都有name字段
              const processNodes = (nodes) => {
                if (!nodes || !Array.isArray(nodes)) return;

                nodes.forEach(node => {
                  // 将label字段映射为name字段
                  if (node.label && !node.name) {
                    node.name = node.label;
                  }

                  // 递归处理子节点
                  if (node.children && Array.isArray(node.children)) {
                    processNodes(node.children);
                  }
                });
              };

              // 处理数据
              processNodes(dataClone);

              // 保存完整的树形结构
              this.nursingAction = {
                name: "护理动作",
                children: dataClone
              };

              // 设置级联选择器使用的数据
              this.childrenList = dataClone;

              // 同时将数据保存到nurser中，避免再次调用API
              this.nurser = res.data.data;

              console.log("从res.data.data处理后的护理动作树形结构:", this.nursingAction);
              console.log("从res.data.data处理后的护理动作列表:", this.childrenList);

              this.$nextTick(() => {
                // 强制刷新级联选择器
                this.childrenList = [...this.childrenList];
              });
            } catch (error) {
              console.error("从res.data.data处理护理动作数据时出错:", error);
              this.$message.error("处理护理动作数据时出错");
            }
          } else {
            this.$message.error("获取护理动作数据结构异常");
          }
        }
        this.isNursingLoading = false; // 结束加载
      }).catch(error => {
        console.error("获取护理动作失败:", error);
        this.$message.error("获取护理动作失败");
        this.isNursingLoading = false; // 结束加载
      });
    },
    expandChange(e) {
      console.log(e, "000");
    },
    //查询老人护理时间线
    findtimeLine(id) {
      this.timelineList = [];
      this.seachUser.forEach((item) => {
        if (id == item.id) {
          this.showUser = [item];
          // 使用深拷贝，避免和 hulitimeline 共享同一个数组引用
          this.timelineList = JSON.parse(JSON.stringify(item.hulitimeline || []));
        }
      });
    },
    // 模糊搜索老人名字（通过ID查询）
    changeName(e) {
      if (!e) {
        this.userInfo();
        return;
      }

      this.isLoading = true; // 开始加载

      getUserinfo({
        id: e,
        name: ''
      }).then((res) => {
        if (res.data) {
          // 修改为正确的数据结构：使用rows数组而不是data
          let seachUser = res.data.rows || [];
          if (seachUser.length === 0) {
            this.$message.info("未找到对应ID的老人信息");
            this.isLoading = false; // 结束加载
            return;
          }

          // 为每个用户获取时间线信息
          let promises = seachUser.map((item, index) => {
            return timeLine({ id: item.id }).then((res) => {
              let line = res.data.data;
              // 处理时间线数据，转换字段名为小写首字母
              if (line && Array.isArray(line)) {
                line = line.map(timeItem => {
                  return {
                    activity: timeItem.Activity || '',
                    activityId: timeItem.ActivityId || '',
                    caregiver: timeItem.Caregiver || 'None',
                    caregiverId: timeItem.CaregiverId || '',
                    timeSlot: timeItem.TimeSlot || ''
                  };
                });
              } else {
                console.warn(`用户 ${item.name} 的时间线数据不是数组或为空`);
                line = [];
              }

              item.hulitimeline = line;

              if (index == 0) {
                // 使用深拷贝，避免共享引用
                this.timelineList = JSON.parse(JSON.stringify(line));
              }

              return item;
            }).catch(error => {
              console.error(`获取用户 ${item.name} 的时间线失败:`, error);
              item.hulitimeline = [];

              if (index == 0) {
                this.timelineList = [];
              }

              return item;
            });
          });

          // 等待所有时间线数据加载完成
          Promise.all(promises).then((updatedUsers) => {
            this.seachUser = updatedUsers;
            this.showUser = updatedUsers;
            this.isLoading = false; // 结束加载
          }).catch(() => {
            this.isLoading = false; // 结束加载
          });
        } else {
          this.isLoading = false; // 结束加载
        }
      }).catch(error => {
        console.error("按ID查询老人信息失败", error);
        this.$message.error("查询老人信息失败");
        this.isLoading = false; // 结束加载
      });
    },
    // 老人模糊搜索（通过姓名）
    remoteMethod(e) {
      console.log(e, "老人模糊搜索");
      if (e && e.trim().length > 0) {
        // 只有当输入内容不为空时才发送请求
        this.isLoading = true; // 开始加载

        getUserinfo({
          id: '',
          name: e
        }).then((res) => {
          if (res.data) {
            // 如果没有搜索结果
            if (!res.data.rows || res.data.rows.length === 0) {
              this.$message.info("未找到匹配的老人信息");
              this.isLoading = false; // 结束加载
              return;
            }

            // 修改为正确的数据结构：使用rows数组
            let seachUser = res.data.rows ? res.data.rows.slice(0, 5) : [];

            // 为每个用户获取时间线信息
            let promises = seachUser.map((item, index) => {
              return timeLine({ id: item.id }).then((res) => {
                let line = res.data.data;
                // 处理时间线数据，转换字段名为小写首字母
                if (line && Array.isArray(line)) {
                  line = line.map(timeItem => {
                    return {
                      activity: timeItem.Activity || '',
                      activityId: timeItem.ActivityId || '',
                      caregiver: timeItem.Caregiver || 'None',
                      caregiverId: timeItem.CaregiverId || '',
                      timeSlot: timeItem.TimeSlot || ''
                    };
                  });
                } else {
                  console.warn(`用户 ${item.name} 的时间线数据不是数组或为空`);
                  line = [];
                }

                item.hulitimeline = line;

                if (index == 0) {
                  this.timelineList = line;
                }

                return item;
              }).catch(error => {
                console.error(`获取用户 ${item.name} 的时间线失败:`, error);
                item.hulitimeline = [];

                if (index == 0) {
                  this.timelineList = [];
                }

                return item;
              });
            });

            // 等待所有时间线数据加载完成
            Promise.all(promises).then((updatedUsers) => {
              this.seachList = res.data.rows || []; // 搜索下拉列表保留所有结果
              this.seachUser = updatedUsers; // 用户展示列表
              this.showUser = updatedUsers;  // 更新showUser以显示搜索结果
              this.isLoading = false; // 结束加载
            }).catch(() => {
              this.isLoading = false; // 结束加载
            });
          } else {
            this.isLoading = false; // 结束加载
          }
        }).catch(error => {
          console.error("模糊搜索老人信息失败", error);
          this.$message.error("搜索失败");
          this.isLoading = false; // 结束加载
        });
      } else {
        // 清空搜索条件时不自动加载所有数据
        this.clearName();
      }
    },

    //搜索框清空
    clearName() {
      // 不再调用userInfo()加载所有数据
      this.seachList = [];
      this.seachUser = [];
      this.showUser = [];
      this.timelineList = [];
      this.username = "";
      this.$message.info("请输入搜索条件");
    },

    //开始拖拽事件
    onStart() {
      this.drag = true;
    },
    //拖拽结束事件
    onEnd() {
      this.drag = false;
    },
    // 选择护理动作
    huliaction(e) {
      console.log("级联选择器选中值:", e);

      if (!e || e.length === 0) {
        console.log("未选中任何项");
        return;
      }

      let leg = e.length;
      let id = leg > 1 ? e[leg - 1] : e[0];

      console.log("选中的ID:", id);
      console.log("当前护理动作数据:", this.childrenList);

      // 递归查找选中的护理动作
      const findSelectedAction = (arr, targetId) => {
        if (!arr || !Array.isArray(arr)) return null;

        for (let item of arr) {
          if (item.id == targetId) {
            // 找到目标节点
            console.log("找到选中的护理动作:", item);
            return item;
          }

          // 递归查找子节点
          if (item.children && item.children.length > 0) {
            const found = findSelectedAction(item.children, targetId);
            if (found) return found;
          }
        }

        return null;
      };

      // 在树形结构中查找选中的护理动作
      const selectedAction = findSelectedAction(this.childrenList, id);

      if (selectedAction) {
        console.log("找到选中的护理动作:", selectedAction);

        // 确保选中项有name字段
        if (selectedAction.label && !selectedAction.name) {
          selectedAction.name = selectedAction.label;
        }

        // 如果是叶子节点（没有children或children为空数组），直接使用该节点
        if (!selectedAction.children || selectedAction.children.length === 0) {
          this.myArray = [selectedAction];
          console.log("设置为叶子节点:", this.myArray);
        } else {
          // 递归获取所有叶子节点的函数
          const getAllLeafNodes = (node) => {
            let result = [];

            // 如果节点没有children或children为空数组，则该节点是叶子节点
            if (!node.children || node.children.length === 0) {
              // 确保节点有name字段
              if (node.label && !node.name) {
                node.name = node.label;
              }
              return [node];
            }

            // 递归获取所有子节点的叶子节点
            node.children.forEach(child => {
              const leafNodes = getAllLeafNodes(child);
              result = result.concat(leafNodes);
            });

            return result;
          };

          // 获取所有叶子节点
          const allLeafNodes = getAllLeafNodes(selectedAction);

          if (allLeafNodes.length > 0) {
            this.myArray = allLeafNodes;
            console.log("设置为所有叶子节点:", this.myArray, "共", allLeafNodes.length, "个");
          } else {
            // 这种情况几乎不会发生
            this.myArray = [selectedAction];
            console.log("没有找到叶子节点，使用选中节点:", this.myArray);
          }
        }

        this.actiontrue = true;
      } else {
        console.error("未找到选中的护理动作，ID:", id);
        this.$message.error("未找到选中的护理动作");
      }
    },
    //护理员模糊搜索
    hulinameMethod(query) {
      console.log("hulinameMethod被调用，查询参数:", query);

      // 无论是否有查询参数，都尝试调用接口
      // 使用新的接口进行护理员模糊查询
      console.log("准备调用getAppUserList接口，参数:", { keyword: query || "" });

      // 构建请求参数
      const params = {
        keyword: query || "" // 如果query为空，传递空字符串
      };

      // 直接调用API
      return getAppUserList(params).then(res => {
        console.log("getAppUserList接口返回:", res);

        if (res.data && res.data.code === 200) {
          // 处理返回的护理员列表数据
          const list = res.data.rows || [];
          console.log("接口返回的原始列表:", list);

          // 直接使用返回的列表数据
          this.nurser = list;

          console.log("处理后的护理员列表:", this.nurser);

          if (this.nurser.length === 0 && query && query.trim().length > 0) {
            this.$message.info("未找到匹配的护理员");
          }
        } else {
          console.error("获取护理员列表返回异常:", res);
          if (query && query.trim().length > 0) {
            this.$message.error("获取护理员列表失败");
          }
        }

        return this.nurser;
      }).catch(error => {
        console.error("获取护理员列表失败:", error);
        if (query && query.trim().length > 0) {
          this.$message.error("获取护理员列表失败，请检查网络连接");
        }
        return [];
      });
    },
    // 清空护理员搜索
    clearhuliName() {
      this.huliname = "";
    },
    // 护理员选择框获得焦点
    onHuliSelectFocus() {
      console.log("护理员选择框获得焦点");

      // 直接调用API获取护理员列表
      console.log("直接调用getAppUserList API");

      // 显示加载消息
      this.$message.info("正在加载护理员列表...");

      getAppUserList({
        keyword: "" // 传递空字符串，加载所有数据
      }).then(res => {
        console.log("直接调用getAppUserList返回:", res);

        if (res.data && res.data.code === 200) {
          // 处理返回的护理员列表数据
          const list = res.data.rows || [];
          console.log("接口返回的原始列表:", list);

          // 直接使用返回的列表数据
          this.nurser = list;

          console.log("处理后的护理员列表:", this.nurser);

          if (this.nurser.length === 0) {
            this.$message.info("未找到护理员数据");
          } else {
            this.$message.success(`成功加载${this.nurser.length}个护理员`);
          }
        } else {
          console.error("获取护理员列表返回异常:", res);
          this.$message.error("获取护理员列表失败");
        }
      }).catch(error => {
        console.error("获取护理员列表失败:", error);
        this.$message.error("获取护理员列表失败，请检查网络连接");
      });
    },

    // 护理员选择框值变化
    onHuliSelectChange(value) {
      console.log("护理员选择框值变化:", value);
    },

    // 护理员选择框下拉菜单显示状态变化
    onHuliSelectVisibleChange(visible) {
      console.log("护理员选择框下拉菜单显示状态变化:", visible);

      // 不再在这里调用API，避免重复请求
      // 已经在onHuliSelectFocus中调用了API
    },
    // 拖拽护理动作
    personadd(id, e) {
      this.Nustime = this.myArray[e.oldIndex];
      let user = this.seachUser.find((item) => item.id == id);

      // 根据现有时间线数据创建一个本地副本
      this.list = user.hulitimeline.map(item => ({...item}));

      if (!this.user || user.id == this.user.id) {
        this.user = user;
        this.chiocepopup = true;
      } else {
        // 可以添加错误提示
        // this.$notify.error({
        //   title: "错误",
        //   message: "该操作不是同一人，请重新拖拽",
        // });
      }
      this.username = user.name;
    },
    persononStart(e) {
      console.log(e, "persononStart");
    },
    personend(e) {
      let id = this.seachUser[e.newIndex].id;
      console.log(id, "eeeeeeeeeeeeeeeee");
    },
    checkMove(evt) {
      console.log(evt);
      return true;
    },
    // 时间字符串转换为分钟数，方便比较
    timeToMinutes(timeStr) {
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    },
    // 检测时间冲突
    checkTimeConflict() {
      // 验证时间是否选择
      if (!this.startTime || !this.endTime) {
        this.$message({
          message: "请选择开始时间和结束时间",
          type: "warning",
        });
        return;
      }

      // 验证结束时间是否大于开始时间
      if (this.startTime >= this.endTime) {
        this.$message({
          message: "结束时间必须大于开始时间",
          type: "warning",
        });
        return;
      }

      const newStart = this.timeToMinutes(this.startTime);
      const newEnd = this.timeToMinutes(this.endTime);
      
      // 创建新项目
      const timeSlot = `${this.startTime}-${this.endTime}`;
      let caregiverName = 'None';
      
      if (this.huliname && this.nurser) {
        const selectedCaregiver = this.nurser.find(nurse => nurse.userId === this.huliname);
        if (selectedCaregiver) {
          caregiverName = selectedCaregiver.nickName || selectedCaregiver.userName;
        }
      }

      const newItem = {
        activity: this.Nustime.name || this.Nustime.label,
        activityId: this.Nustime.id,
        caregiver: caregiverName,
        caregiverId: this.huliname || '',
        timeSlot: timeSlot
      };

      // 检测冲突
      const conflicts = [];
      const MIN_DURATION = 5; // 最小任务时长（分钟）
      
      this.timelineList.forEach((item, index) => {
        const itemTimes = item.timeSlot.split('-');
        if (itemTimes.length !== 2) return;
        
        const itemStart = this.timeToMinutes(itemTimes[0]);
        const itemEnd = this.timeToMinutes(itemTimes[1]);
        
        // 检测是否有重叠
        if (newStart < itemEnd && newEnd > itemStart) {
          // 有重叠，计算如何调整
          let newItemStart = null;
          let newItemEnd = null;
          let type = null;
          
          // 情况1: 新任务完全覆盖现有任务
          if (newStart <= itemStart && newEnd >= itemEnd) {
            type = 'delete';
          }
          // 情况2: 新任务覆盖现有任务的开头部分
          else if (newStart <= itemStart && newEnd > itemStart && newEnd < itemEnd) {
            newItemStart = this.endTime;
            newItemEnd = itemTimes[1];
            const remainingDuration = itemEnd - newEnd;
            type = 'modify'; // 只要有剩余时间就保留，不删除
          }
          // 情况3: 新任务覆盖现有任务的结尾部分
          else if (newStart > itemStart && newStart < itemEnd && newEnd >= itemEnd) {
            newItemStart = itemTimes[0];
            newItemEnd = this.startTime;
            type = 'modify'; // 只要有剩余时间就保留，不删除
          }
          // 情况4: 新任务在现有任务中间（分割现有任务为两段）
          else if (newStart > itemStart && newEnd < itemEnd) {
            // 分割成两部分：前半部分和后半部分
            // 使用 split 类型表示需要分割
            type = 'split';
            
            // 存储分割信息（总是保留两段）
            conflicts.push({
              index: index,
              type: 'split',
              original: item,
              frontTimeSlot: `${itemTimes[0]}-${this.startTime}`,
              backTimeSlot: `${this.endTime}-${itemTimes[1]}`
            });
            return; // 已经 push 了，跳过后面的 push
          }
          
          if (type) {
            conflicts.push({
              index: index,
              type: type,
              original: item,
              newTimeSlot: type === 'modify' ? `${newItemStart}-${newItemEnd}` : null
            });
          }
        }
      });

      // 检查是否有真正的冲突（会导致任务被删除）
      const hasDeleteConflict = conflicts.some(c => c.type === 'delete');
      
      if (hasDeleteConflict) {
        // 有任务会被删除，需要弹窗确认
        this.conflictPreview = conflicts.filter(c => c.type === 'delete');
        this.pendingNewItem = newItem;
        // 保存需要自动处理的调整项
        this.pendingAdjustments = conflicts.filter(c => c.type === 'modify' || c.type === 'split');
        this.conflictDialogVisible = true;
      } else if (conflicts.length > 0) {
        // 只有调整，不需要确认，直接处理
        this.applyAdjustments(conflicts);
        this.addNewItemToTimeline(newItem);
      } else {
        // 没有任何冲突，直接添加
        this.addNewItemToTimeline(newItem);
      }
    },
    // 确认添加（处理冲突后）
    confirmWithConflict() {
      // 先处理 delete 类型（需要确认的冲突）
      const sortedDeletes = [...this.conflictPreview].sort((a, b) => b.index - a.index);
      
      sortedDeletes.forEach(conflict => {
        if (conflict.type === 'delete') {
          // 删除该项
          this.timelineList.splice(conflict.index, 1);
          if (this.user) {
            const userIndex = this.user.hulitimeline.findIndex(
              item => item.timeSlot === conflict.original.timeSlot && item.activity === conflict.original.activity
            );
            if (userIndex !== -1) {
              this.user.hulitimeline.splice(userIndex, 1);
            }
          }
        }
      });

      // 处理 modify/split 类型（不需要确认的调整）
      if (this.pendingAdjustments && this.pendingAdjustments.length > 0) {
        this.applyAdjustments(this.pendingAdjustments);
      }

      // 添加新项目
      this.addNewItemToTimeline(this.pendingNewItem);

      // 关闭冲突弹窗并清理
      this.conflictDialogVisible = false;
      this.conflictPreview = [];
      this.pendingNewItem = null;
      this.pendingAdjustments = [];
    },
    // 应用时间调整（不需要确认的 modify/split）
    applyAdjustments(adjustments) {
      // 按索引从大到小排序，避免删除时索引错乱
      const sorted = [...adjustments].sort((a, b) => b.index - a.index);
      
      sorted.forEach(conflict => {
        if (conflict.type === 'modify') {
          // 修改该项的时间
          this.timelineList[conflict.index].timeSlot = conflict.newTimeSlot;
          if (this.user) {
            const userItem = this.user.hulitimeline.find(
              item => item.timeSlot === conflict.original.timeSlot && item.activity === conflict.original.activity
            );
            if (userItem) {
              userItem.timeSlot = conflict.newTimeSlot;
            }
          }
        } else if (conflict.type === 'split') {
          // 分割：先删除原任务
          this.timelineList.splice(conflict.index, 1);
          if (this.user) {
            const userIndex = this.user.hulitimeline.findIndex(
              item => item.timeSlot === conflict.original.timeSlot && item.activity === conflict.original.activity
            );
            if (userIndex !== -1) {
              this.user.hulitimeline.splice(userIndex, 1);
            }
          }
          
          // 添加前半部分
          if (conflict.frontTimeSlot) {
            const frontItem = { ...conflict.original, timeSlot: conflict.frontTimeSlot };
            this.timelineList.push(frontItem);
            if (this.user) {
              this.user.hulitimeline.push(frontItem);
            }
          }
          
          // 添加后半部分
          if (conflict.backTimeSlot) {
            const backItem = { ...conflict.original, timeSlot: conflict.backTimeSlot };
            this.timelineList.push(backItem);
            if (this.user) {
              this.user.hulitimeline.push(backItem);
            }
          }
        }
      });
    },
    // 添加新项目到时间线
    addNewItemToTimeline(newItem) {
      console.log("添加新的护理动作到时间线:", newItem);

      // 添加到时间线
      this.timelineList.push(newItem);
      
      // 按时间排序
      this.timelineList.sort((a, b) => {
        const timeA = a.timeSlot.split('-')[0];
        const timeB = b.timeSlot.split('-')[0];
        return timeA.localeCompare(timeB);
      });

      // 同时更新 user 的时间线数据
      if (this.user) {
        this.user.hulitimeline.push(newItem);
        this.user.hulitimeline.sort((a, b) => {
          const timeA = a.timeSlot.split('-')[0];
          const timeB = b.timeSlot.split('-')[0];
          return timeA.localeCompare(timeB);
        });
      }

      // 添加到待保存列表
      this.list2.push({...newItem});

      if (this.firstSelection) {
        this.firstSelection = false;
      }

      this.$message({
        message: "护理动作添加成功",
        type: "success",
      });

      this.chiocepopup = false;
      this.startTime = "";
      this.endTime = "";
      this.huliname = "";
    },
    // 原来的 ConfirmPop 保留，但改为内部调用（可用于其他场景）
    ConfirmPop() {
      this.checkTimeConflict();
    },
    CancelPop() {
      if (this.firstSelection) {
        this.user = null;
      }
      this.chiocepopup = false;
      this.startTime = "";
      this.endTime = "";
      this.huliname = "";
    },
    //生成计划（已暂停维护）
    clickbaocun() {
      // 注释掉原有的接口调用
      /*
      adjust(this.list2).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "生成计划成功，点击信息查看",
            type: "success",
          });
          this.userInfo();
          this.list = [];
          this.list2 = [];
          this.user = null;
        } else {
          this.list = [];
          this.list2 = [];
        }
      });
      */

      // 显示维护提示
      this.$notify({
        title: "系统维护",
        message: "生成计划功能正在维护中，暂时不可用",
        type: "warning",
        duration: 3000
      });
    },
    // 时间线方法
    right(resolve) {
      resolve();
      this.rightComplete = true;
    },
    left(resolve) {
      resolve();
      this.leftComplete = true;
    },
    setupTouchEvents() {
      if (!this.$refs.timeline) return;

      const timelineEl = this.$refs.timeline.$el.querySelector('.timeline-container');
      if (!timelineEl) return;

      timelineEl.addEventListener('touchstart', this.handleTouchStart, { passive: false });
      timelineEl.addEventListener('touchmove', this.handleTouchMove, { passive: false });
      timelineEl.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    },
    handleTouchStart(event) {
      const touch = event.touches[0];
      this.touchStartX = touch.pageX;
      this.touchStartY = touch.pageY;
      this.isTouching = true;

      event.preventDefault();
    },
    handleTouchMove(event) {
      if (!this.isTouching) return;

      const touch = event.touches[0];
      const deltaX = this.touchStartX - touch.pageX;

      const timelineRef = this.$refs.timeline.$refs.timelineRef;
      if (!timelineRef) return;

      timelineRef.scrollLeft += deltaX;

      this.touchStartX = touch.pageX;

      event.preventDefault();
    },
    handleTouchEnd() {
      this.isTouching = false;
    },
    // 测试查询方法 - 固定使用id=23进行查询（已暂停维护）
    testSearch() {
      // 注释掉原有的固定ID查询逻辑
      /*
      const fixedId = "23";
      this.$message.info(`正在查询ID：${fixedId}`);
      this.isLoading = true; // 开始加载

      getUserinfo({
        id: fixedId,
        name: ''
      }).then((res) => {
        // 原有查询逻辑已注释
      }).catch(error => {
        console.error("测试查询失败", error);
        this.$message.error("测试查询失败");
        this.isLoading = false; // 结束加载
      });
      */

      // 显示维护提示（如果此方法被直接调用）
      this.$message.info("系统正在维护中，此功能暂时不可用");
    },
    reloadNursingAction() {
      console.log("当前护理动作数据:", this.childrenList);
      console.log("当前护理动作结构:", this.nursingAction);
      this.findnursing();
    },
  },
  beforeDestroy() {
    if (!this.$refs.timeline) return;

    const timelineEl = this.$refs.timeline.$el.querySelector('.timeline-container');
    if (!timelineEl) return;

    timelineEl.removeEventListener('touchstart', this.handleTouchStart);
    timelineEl.removeEventListener('touchmove', this.handleTouchMove);
    timelineEl.removeEventListener('touchend', this.handleTouchEnd);
  },
};
</script>

<style scoped lang='less'>
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #074e56 !important;
}

/deep/ .el-select-dropdown {
  background-color: #21585e !important;
}

/deep/ .el-select-dropdown__item {
  color: white !important;
}

.huli {
  /deep/ .el-input__inner {
    background-color: #0a313a !important;
    border-radius: 20px;
    border: 1px solid #039dad;
    color: #ffffff;
  }
}

.search {
  /deep/ .el-input__inner {
    background-color: #0a313a !important;
    border-radius: 20px;
    border: 1px solid #039dad;
    color: aqua;
  }
}

/deep/.el-timeline-item__content {
  color: #00ffff;
}

/deep/.el-timeline-item__timestamp {
  color: #d5d6d9;
}

/deep/.el-timeline-item__node {
  background-color: #00ffff;
}

.history {
  .el-button {
    background: #0d3a45;
    border: 1px solid #07ffff;
    color: #00ffff;
  }
}

/deep/.el-dialog {
  background-image: url(../assets/about/huliimg.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #054f4e;
  // width: 27vw;
  // height: 35vh;
  width: 573px;
  height: 350px;
  // z-index: 9999;
}

/deep/.el-form-item__label {
  color: white;
}

/deep/.el-dialog__title {
  color: white;
}

.userinfo {
  width: 30%;

  // background-color: red;
  position: relative;
  transform: rotate(-45deg);
  animation: heartbeat 1s infinite;
}

.userinfo:hover + .elementB {
  display: block;
}
.userinfo::before,
.userinfo::after {
  content: "";
  width: 30%;
  position: absolute;
}

.userinfo::before {
  top: -50px;
  left: 0;
}

.userinfo::after {
  left: 50px;
  top: 0;
}

.el-timeline {
  height: 20vh;
  overflow: scroll;
  scrollbar-width: none;
  padding: 6vh 1vh 2vh 2vh;
}

@keyframes heartbeat {
  0%,
  20%,
  40%,
  60%,
  80%,
  100% {
    transform: scale(1);
  }

  10% {
    transform: scale(1.03);
  }

  30% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.03);
  }

  70% {
    transform: scale(1);
  }
}
</style>
<style lang="less" scoped>
.about {
  width: 100%;
  background: url(../assets/about/aboutpng.jpg) no-repeat;
  background-size: 100% 100%;

  .bodyblock {
    width: 96%;
    margin: 0 auto;

    .header {
      height: 15vh;
      background: url(../assets/about/header.gif) no-repeat;
      background-size: 100% 100%;

      h1 {
        color: white;
        line-height: 7vh;
      }
    }

    .searchblock {
      width: 30%;
      height: 5vh;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .mian {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .leftblock {
      width: 45%;
      height: 50vh;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      align-items: center;

      .huli_time {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        align-content: flex-end;
        height: 8vh;
        color: white;

        .chiocetime {
          font-size: 0.8em;
          color: gray;
          height: 4vh;
          line-height: 4vh;
          width: 100%;
        }
      }

      .usertitle {
        height: 4vh;
        width: 92%;
        line-height: 4vh;
        color: white;
        background: url(../assets/about/solit2.png) no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 3%;
        left: 6%;
      }

      .userinfo {
        width: 22%;
        position: relative;
        margin: 2vh 0;

        .drag-wrapper {
          height: 25vh;
          width: 100%;
          background: url(../assets/about/leftblock.png) no-repeat;
          background-size: 100% 100%;
          overflow: scroll;
          scrollbar-width: none;

          .userbody {
            position: relative;

            .line {
              height: 28vh;
              overflow: auto;
              position: absolute;
              top: 5vh;
              scrollbar-width: none;
              padding-left: 1vw;
            }
          }
        }
      }
      .tooltip {
        display: none; /* 默认隐藏 */
        position: absolute; /* 绝对定位 */
        color: #fff; /* 字体颜色 */
        padding: 5px; /* 内边距 */
        border-radius: 4px; /* 圆角 */
        left: 50%; /* 居中对齐 */
        transform: translateX(-50%); /* 通过平移调整居中 */
        z-index: 100; /* 确保在最上层 */
        background: #e4e7ed45;
        width: 100%;
      }
      .userinfo:hover .tooltip {
        display: block; /* 鼠标悬停时显示 */
      }
    }
    .centerblock {
      width: 50%;
      height: 50vh;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;

      .setandhuli {
        width: 30%;
        margin-right: 10vw;

        // display: flex;
        // .online{
        //   width: 2vw;
        //   height: 1.5vh;
        //   img{
        //     width: 100%;
        //     height: 100%;
        //   }
        // }
        .huli {
          height: 50vh;
          width: 100%;
          background: url(../assets/about/left.png) no-repeat;
          background-size: 100% 100%;
          margin: 0 auto;

          .actionitem {
            height: 39vh;
            overflow: auto;
            scrollbar-width: none;
          }

          .item {
            padding: 0.5vw;
            background-color: #062029;
            border: solid 1px #4ed0dc;
            margin-bottom: 10px;
            cursor: move;
            width: 60%;
            margin: 0 auto;
            color: #0b9db1;
            cursor: pointer;
          }

          /*选中样式*/
          .chosen {
            border: solid 2px #3089dc !important;
          }

          .hulititle {
            color: #00ffff;
            font-size: 1.3em;
            text-align: center;
            width: 44%;
            height: 5vh;
            line-height: 5vh;
          }

          .block {
            width: 90%;
            margin: 0 auto;
          }
        }
      }

      .cenicon {
        height: 4vh;
        position: relative;
        top: 0;
        right: 0;

        img {
          height: 2.5vh;
        }
      }

      .setblock {
        position: relative;

        .set {
          background: #041d23;
          height: 100%;
          border-radius: 5%;
          padding: 1vw;
          box-sizing: border-box;

          /deep/.el-button.is-round {
            padding: 9px 50px;
            cursor: pointer;
          }

          /deep/ .el-button {
            background: #0d3a45;
            border: 1px solid #04ffe1;
            color: #00ffff;
          }

          div {
            padding-top: 2.5vw;
            cursor: pointer;
          }

          // .history {
          //   display: flex;
          // }
        }

        .closeicon {
          height: 4vh;
          position: absolute;
          top: 0;
          right: 0;

          img {
            height: 3vh;
          }
        }
      }
    }
  }
}

.horizontal-timeline {
  margin-top: 40px;
  margin-bottom: 30px;
  width: 100%;
  touch-action: pan-y;
}

.content {
  // opacity: 0.5;
  // padding-bottom: 10px;
  width: 120px;
  height: 90px;
  font-size: 16px;
  color: #00ffff;
  border-radius: 10px;
  border: 1px solid #00ffff;
  padding: 0 10px;
}

.chat {
  position: relative;
  min-width: 100px;
  max-width: 180px;
  word-wrap: break-word;
  padding-top: 12px;
}

.time {
  color: #fff;
  position: absolute;
  top: -25px;
}

.elderInfo {
  // position: relative;
  position: relative;
  top: 20px;
  width: 100%;
  margin: auto 0;
  color: #fff;
  font-size: 20px;
}
.zhiliang {
  background: #04626c;
  width: 150px;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
  float: right;
  margin-top: 20px;
  a {
    color: white;
    text-decoration: none;
  }
}
</style>
